"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var React = __importStar(require("react"));
var styledLayout_1 = require("../base/styledLayout");
var inputWrapper_1 = require("../inputWrapper");
var form_1 = require("../form");
var react_input_mask_1 = __importDefault(require("react-input-mask"));
exports.MaskedInput = React.memo(function (_a) {
    var mask = _a.mask, name = _a.name, placeholder = _a.placeholder, type = _a.type, message = _a.message, transformer = _a.transformer, onChange = _a.onChange, onFocus = _a.onFocus, onBlur = _a.onBlur, onlyChildren = _a.onlyChildren, controlledValue = _a.controlledValue, _b = _a.alwaysShowMask, alwaysShowMask = _b === void 0 ? false : _b, _c = _a.maskPlaceholder, maskPlaceholder = _c === void 0 ? '_' : _c, _d = _a.passive, passive = _d === void 0 ? false : _d, _e = _a.size, size = _e === void 0 ? "small" /* Small */ : _e, _f = _a.label, label = _f === void 0 ? '' : _f, _g = _a.defaultValue, defaultValue = _g === void 0 ? '' : _g, forwardedRef = _a.forwardedRef;
    var _h = form_1.useForm(defaultValue, name, type, message), input = _h[0], setInput = _h[1], _type = _h[2], _message = _h[3];
    var textboxClassName = classnames_1.default('ty-input', 'ty-textbox', 'ty-bordered', "ty-input-" + size);
    var _onChange = function (event) {
        var input = event.currentTarget.value;
        if (transformer && typeof transformer === 'function') {
            input = transformer(input);
        }
        setInput(input);
        if (typeof onChange === 'function') {
            onChange(input, event);
        }
    };
    React.useMemo(function () {
        setInput(controlledValue || '');
    }, [controlledValue]);
    return (React.createElement(inputWrapper_1.InputWrapper, { passive: passive, type: _type, message: _message, label: label, size: size, onlyChildren: onlyChildren },
        React.createElement(react_input_mask_1.default, { mask: passive ? '' : mask, value: input, onChange: _onChange, onFocus: onFocus, onBlur: onBlur, disabled: passive, alwaysShowMask: alwaysShowMask, placeholder: placeholder, maskPlaceholder: maskPlaceholder, 
            // input props
            name: name, 
            // custom props
            className: textboxClassName },
            React.createElement(styledLayout_1.StyledLayout, { 
                // style props
                elementType: "input" /* Input */, backgroundColor: "ty-bg-beige" /* Beige */, forwardedRef: forwardedRef }))));
});
